export default __webpack_public_path__ + "static/media/logo.8274a3d2.png";